export default ".word-breaker {\n  overflow-wrap: break-word;\n}\n";